var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 176,
    viewBox: "0 0 207 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.43504,
    cy: 88.436,
    r: 4,
    transform: "rotate(-118.904 5.43504 88.436)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0011,
    cy: 67.9852,
    r: 4,
    transform: "rotate(-179.984 22.0011 67.9852)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0011,
    cy: 49.9911,
    r: 4,
    transform: "rotate(-179.984 42.0011 49.9911)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0011,
    cy: 28.0009,
    r: 4,
    transform: "rotate(-179.984 64.0011 28.0009)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.0011,
    cy: 10.0009,
    r: 4,
    transform: "rotate(-179.984 84.0011 10.0009)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4074,
    cy: 108.439,
    r: 4,
    transform: "rotate(-27.9208 22.4074 108.439)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0691,
    cy: 126.322,
    r: 4,
    transform: "rotate(-89.0009 42.0691 126.322)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0691,
    cy: 152.068,
    r: 4,
    transform: "rotate(-89.0009 64.0691 152.068)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.0691,
    cy: 171.068,
    r: 4,
    transform: "rotate(-89.0009 84.0691 171.068)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.435,
    cy: 85.436,
    r: 4,
    transform: "rotate(-118.904 43.435 85.436)",
    fill: "#3A6EE8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0011,
    cy: 64.9852,
    r: 4,
    transform: "rotate(-179.984 60.0011 64.9852)",
    fill: "#3A6EE8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0011,
    cy: 46.9911,
    r: 4,
    transform: "rotate(-179.984 80.0011 46.9911)",
    fill: "#3A6EE8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.001,
    cy: 25.0009,
    r: 4,
    transform: "rotate(-179.984 102.001 25.0009)",
    fill: "#3A6EE8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.001,
    cy: 7.00086,
    r: 4,
    transform: "rotate(-179.984 122.001 7.00086)",
    fill: "#3A6EE8"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4074,
    cy: 105.439,
    r: 4,
    transform: "rotate(-27.9208 60.4074 105.439)",
    fill: "#3A6EE8"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0691,
    cy: 123.322,
    r: 4,
    transform: "rotate(-89.0009 80.0691 123.322)",
    fill: "#3A6EE8"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.069,
    cy: 149.068,
    r: 4,
    transform: "rotate(-89.0009 102.069 149.068)",
    fill: "#3A6EE8"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.069,
    cy: 168.068,
    r: 4,
    transform: "rotate(-89.0009 122.069 168.068)",
    fill: "#3A6EE8"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.435,
    cy: 85.436,
    r: 4,
    transform: "rotate(-118.904 85.435 85.436)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.001,
    cy: 64.9852,
    r: 4,
    transform: "rotate(-179.984 102.001 64.9852)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.001,
    cy: 46.9911,
    r: 4,
    transform: "rotate(-179.984 122.001 46.9911)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.001,
    cy: 25.0009,
    r: 4,
    transform: "rotate(-179.984 144.001 25.0009)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.001,
    cy: 7.00086,
    r: 4,
    transform: "rotate(-179.984 164.001 7.00086)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.407,
    cy: 105.439,
    r: 4,
    transform: "rotate(-27.9208 102.407 105.439)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.069,
    cy: 123.322,
    r: 4,
    transform: "rotate(-89.0009 122.069 123.322)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.069,
    cy: 149.068,
    r: 4,
    transform: "rotate(-89.0009 144.069 149.068)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.069,
    cy: 168.068,
    r: 4,
    transform: "rotate(-89.0009 164.069 168.068)",
    fill: "black",
    fillOpacity: 0.7
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.435,
    cy: 82.436,
    r: 4,
    transform: "rotate(-118.904 123.435 82.436)",
    fill: "#3A6EE8"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.001,
    cy: 61.9852,
    r: 4,
    transform: "rotate(-179.984 140.001 61.9852)",
    fill: "#3A6EE8"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.001,
    cy: 43.9911,
    r: 4,
    transform: "rotate(-179.984 160.001 43.9911)",
    fill: "#3A6EE8"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.001,
    cy: 22.0009,
    r: 4,
    transform: "rotate(-179.984 182.001 22.0009)",
    fill: "#3A6EE8"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.001,
    cy: 4.00086,
    r: 4,
    transform: "rotate(-179.984 202.001 4.00086)",
    fill: "#3A6EE8"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.407,
    cy: 102.439,
    r: 4,
    transform: "rotate(-27.9208 140.407 102.439)",
    fill: "#3A6EE8"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.069,
    cy: 120.322,
    r: 4,
    transform: "rotate(-89.0009 160.069 120.322)",
    fill: "#3A6EE8"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.069,
    cy: 146.068,
    r: 4,
    transform: "rotate(-89.0009 182.069 146.068)",
    fill: "#3A6EE8"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.069,
    cy: 165.068,
    r: 4,
    transform: "rotate(-89.0009 202.069 165.068)",
    fill: "#3A6EE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots3);
export default __webpack_public_path__ + "static/media/dots3.0ad0220bee4699dc1fa4b0e0793d9cd7.svg";
export { ForwardRef as ReactComponent };